import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonCol, IonRow, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonGrid, useIonViewDidEnter } from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';
import { Descriptions, Row, Col, notification, Table, Tag, Form } from 'antd';
import { Card } from 'antd';
import { Switch } from 'antd';
import { Input } from 'antd';
import moment from 'moment';
import { PageHeader } from 'antd';
import { Modal, } from 'antd';
import { DatePicker, Space } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { DataGrid, GridCellParams, GridToolbar } from '@mui/x-data-grid';
import { useDemoData } from '@mui/x-data-grid-generator';
import { makeStyles } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';




const RoomDetails: React.FC = (props: any) => {

    const useStyles1 = makeStyles((theme) => ({
        root: {
            '& > *': {
                margin: theme.spacing(1),
                width: '25ch',
            },
        },
    }));

    const useStyles = makeStyles((theme) => ({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
        },
        selectEmpty: {
            marginTop: theme.spacing(2),
        },
    }));

    const classes = useStyles();

    //room amenities
    const columns = [

        { field: 'Name', headerName: 'NAME', width: 200 },
        { field: 'Status', headerName: 'STATUS', width: 200 },
        { field: 'Room', headerName: 'ROOM', width: 200 },

    ];
    //room Equiment
    const columns1 = [

        { field: 'Name', headerName: 'NAME', width: 200 },
        { field: 'Status', headerName: 'STATUS', width: 200 },
    ];



    const [data1, SetData1] = useState([]);

    const [data2, SetData2] = useState([]);



    // useIonViewDidEnter(() => {

    //   axios.get('https://dev.northroom.co.za/api/bizprop/lessors/all')
    //     .then(function (response) {
    //       // handle success
    //       console.log(response.data);
    //       SetData(response.data);
    //     })
    //     .catch(function (error) {
    //       // handle error
    //       console.log(error);
    //     })
    //     .then(function () {
    //       // always executed
    //     });


    // });


    const { name } = useParams<{ name: string; }>();
    const { Column, ColumnGroup } = Table;
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = (record: any) => {

        let MainRecord = JSON.parse(record);
        console.log(record);

        setState(prevstate => ({ ...prevstate, ...MainRecord }));

        setIsModalVisible(true);
    };

    const [selectedDate, setSelectedDate] = React.useState<Date | null>(
        new Date('2014-08-18T21:11:54'),
    );

    const handleDateChange = (date: Date | null) => {
        setSelectedDate(date);
    }

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };
    const user = JSON.parse(localStorage.getItem("userobject") || '{}');

    const [PropertyObject, setState] = useState({


    });
    const handleChange = (e: { target: { name: any; value: any; }; }) => {
        // const { name, value } = e.target;
        // setState(prevState => ({
        //   ...prevState,
        //   [name]: value
        // }));

        // setState(prevState => ({
        //   ...prevState,
        //   userid: user.id
        // }));
    };

    const handleChangecheckbox = (e: any, name: any) => {

        setState(prevState => ({
            ...prevState,
            [name]: e
        }));
    };

    return (

        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonRow>
                        <PageHeader
                            className="site-page-header"
                            title="Property Details"

                        />
                    </IonRow>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen >
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large">{name}</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <Space direction="vertical">
                    <IonGrid>
                        <IonRow>
                            <IonCol size="11" style={{ paddingLeft: "40px" }}>
                                <IonCard>
                                    <IonCardHeader>


                                    </IonCardHeader>

                                    <IonCardContent>

                                        <IonRow>
                                            <IonCol>
                                                {/* @ts-ignore */}
                                                <TextField id="outlined-basic" label="Room no" variant="outlined" value={PropertyObject.Name} />
                                            </IonCol>
                                        </IonRow>

                                        <br></br>


                                        <h2><strong>List of Rooms Amenities</strong></h2>
                                        <hr></hr>

                                        <div style={{ height: 400, width: '80vw', paddingRight: "2vw" }}>

                                            <DataGrid
                                                rows={data1}
                                                columns={columns}
                                                components={{
                                                    Toolbar: GridToolbar,
                                                }}
                                                filterModel={{
                                                    items: [
                                                        { columnField: 'Name', operatorValue: 'contains', value: '' },
                                                    ],
                                                }}
                                            />
                                        </div>
                                        <br></br>
                                        <IonRow>
                                            <IonCol>
                                                <h2><strong>List of Room Equipment</strong></h2>
                                                <div style={{ height: 400, width: '80vw', paddingRight: "2vw" }}>

                                                    <DataGrid
                                                        rows={data2}
                                                        columns={columns1}
                                                        components={{
                                                            Toolbar: GridToolbar,
                                                        }}
                                                        filterModel={{
                                                            items: [
                                                                { columnField: 'Name', operatorValue: 'contains', value: '' },
                                                            ],
                                                        }}
                                                    />
                                                </div>
                                            </IonCol>
                                        </IonRow>

                                        <IonRow>
                                            <IonCol>
                                                <TextField id="standard-basic" label="Monthly rent amount" />
                                            </IonCol>

                                            <IonCol>
                                                <label><strong>Status</strong></label>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    style={{ width: "100px" }}
                                                // value={age}
                                                // onChange={handleChange}
                                                >
                                                    <MenuItem value={10}> Available for rent</MenuItem>
                                                    <MenuItem value={20}> Booked</MenuItem>
                                                    <MenuItem value={20}> If Booked</MenuItem>

                                                </Select>
                                            </IonCol>
                                        </IonRow>


                                        <IonRow>
                                            <IonCol>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                    <KeyboardDatePicker
                                                        margin="normal"
                                                        id="date-picker-dialog"
                                                        label="Date picker dialog"
                                                        format="MM/dd/yyyy"
                                                        value={selectedDate}
                                                        onChange={handleDateChange}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change date',
                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </IonCol>

                                        </IonRow>

                                        <IonRow>

                                            <IonCol>
                                                <TextField id="standard-basic" label="Client Name:" />


                                            </IonCol>
                                            <IonCol>
                                                <TextField id="standard-basic" label="Client contact No:" />

                                            </IonCol>

                                        </IonRow>






                                    </IonCardContent>
                                </IonCard>
                            </IonCol>
                        </IonRow>
                    </IonGrid>

                </Space>
            </IonContent>
        </IonPage>

    );
}

export default RoomDetails;